var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-toast a-fix-bottom",class:[{'a-hidden':!_vm.show}, _vm.typeClass]},[(_vm.showClose)?_c('div',{staticClass:"a-toast-close",on:{"click":_vm.onClickClose}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"a-toast-msg"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f5f875a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/base/components/notification.vue
// module id = null
// module chunks = 